import React from 'react';
import { Badge, Tooltip, Typography } from 'antd';
import {
  CheckOutlined,
  SendOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { relativeTime } from '../../utils/relativeTime';

const { Text } = Typography;

function statusLabel(status) {
  if (status === 'answered') return 'Answered';
  if (status === 'refused_off_topic') return 'Declined (off-topic)';
  if (status === 'refused_no_data') return 'Declined (no data)';
  return status || 'Unknown';
}

function chatTypeIcon(chatType) {
  if (chatType === 'private') {
    return <UserOutlined className="messenger-chat-icon messenger-chat-icon--dm" />;
  }
  return <TeamOutlined className="messenger-chat-icon messenger-chat-icon--group" />;
}

function previewLine(conversation, title) {
  const { last_preview: preview, last_sender_name: senderName, chat_type: chatType } = conversation;
  if (!preview) return 'No messages yet';
  const isPrivate = chatType === 'private';
  const sender = senderName || (isPrivate ? title : 'User');
  return `${sender}: ${preview}`;
}

export default function ChatListItem({
  conversation,
  active,
  onClick,
  platform = 'telegram_userbot',
}) {
  const {
    platform_chat_id: chatId,
    chat_type: chatType,
    chat_title: chatTitle,
    last_status: lastStatus,
    last_activity_at: lastAt,
    participants = [],
    declined_count: declinedCount,
  } = conversation;

  const isPrivate = chatType === 'private';
  const title = chatTitle || (isPrivate && participants[0]) || chatId;
  const subtitle = previewLine(conversation, title);

  return (
    <button
      type="button"
      className={`messenger-chat-item${active ? ' messenger-chat-item--active' : ''}`}
      onClick={onClick}
    >
      <div className="messenger-chat-item-avatar">
        {chatTypeIcon(chatType)}
        {platform === 'telegram_userbot' && (
          <SendOutlined className="messenger-chat-platform-badge" />
        )}
      </div>
      <div className="messenger-chat-item-content">
        <div className="messenger-chat-item-top">
          <Text strong ellipsis className="messenger-chat-item-title">
            {title}
          </Text>
          <Text type="secondary" className="messenger-chat-item-time">
            {relativeTime(lastAt)}
          </Text>
        </div>
        <div className="messenger-chat-item-bottom">
          <Text type="secondary" ellipsis className="messenger-chat-item-preview">
            {subtitle}
          </Text>
          <div className="messenger-chat-item-badges">
            {lastStatus === 'answered' && (
              <Tooltip title={statusLabel(lastStatus)}>
                <CheckOutlined className="messenger-status-tick" />
              </Tooltip>
            )}
            {lastStatus?.startsWith('refused') && (
              <Tooltip title={statusLabel(lastStatus)}>
                <span className="messenger-status-dot messenger-status-dot--declined" />
              </Tooltip>
            )}
            {declinedCount > 0 && (
              <Badge count={declinedCount} size="small" style={{ marginLeft: 4 }} />
            )}
          </div>
        </div>
      </div>
    </button>
  );
}
